import React from 'react'
import './index.less'

class ShoppingMallYika extends React.Component {
    skipToDetailMemo = (url) => {
        window.location = url
    }

    getPro (data) {
        let tempAry = []; const proAry = []
        data.forEach((val, index) => {
            tempAry.push(val)
            if (index % 2 !== 0) {
                proAry.push(tempAry)
                tempAry = []
            } else if ((index + 1) === data.length) {
                proAry.push(tempAry)
            }
        })
        return proAry
    }

    render () {
        const { buriedPointEvent, data: { position, trackId, sublist = [] } } = this.props
        return (
            <div className={'shoppingMallYikaContainer'} >
                {
                    this.getPro(sublist).map((itemer, idx) => {
                        return (
                            <ul key={idx}>
                                {
                                    itemer.map((item, index) => {
                                        return (
                                            <li
                                                className={'goodsItem statistics-dom'}
                                                key={index}
                                                onClick={() => {
                                                    buriedPointEvent({
                                                        button_name: `${trackId}-${item.productName}`,
                                                        button_id: `${item.id}`,
                                                        button_order: `${index + 1}`,
                                                        area_order: position,
                                                        button_area: `${position}-${trackId}`
                                                    })
                                                    this.skipToDetailMemo(item.url)
                                                }}
                                            >
                                                <div className={'goodsImg'}>
                                                    <img src={item.imagePath} alt="" />
                                                    {item.instalmentPeriods === '1' ? (<i>30天免息</i>) : null}

                                                </div>
                                                <p className={'twoline'}>{item.productName}</p>
                                                <p className={'moneyContainer'}>
                                                    {item.instalmentPrice ? (<span className={'goodsMoney'}><i>￥</i>{item.instalmentPrice}</span>) : null}
                                                    {item.instalmentPeriods !== '1' && item.instalmentPeriods ? (<span className={'goodsPeriods'}>起/{item.instalmentPeriods}期</span>) : null}
                                                </p>
                                            </li>
                                        )
                                    })
                                }

                            </ul>
                        )
                    })
                }

            </div>
        )
    }
}

export default ShoppingMallYika
